import { Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  AutoCompleteMulti,
  FormInput,
  SwitchInput,
} from "@4uhub/lib4uhub";
import RolesEstablishments from "./RolesEstablishments";
import RolesPrivileges from "./RolesPrivileges";
import ProfilesService from "../../../../services/profiles.service";

const translationPath = "page.register.roles.";

const profilesService = new ProfilesService();

interface IRolesBasicDataProps {
  showPrivileges: boolean;
}

const RolesBasicData = ({ showPrivileges }: IRolesBasicDataProps) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} textAlign={"end"}>
        <SwitchInput
          name="enable"
          label={t(translationPath + "enable") || "Enable"}
        />
      </Grid>

      <Grid item xs={12}>
        <FormInput
          size="small"
          autoFocus={true}
          name="name"
          label={t(translationPath + "name") || "Name"}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <FormInput
          size="small"
          multiline
          name="description"
          fullWidth
          minRows={4}
          label={t(translationPath + "description") || "Description"}
        />
      </Grid>

      <Grid item xs={12} sm={12} mt={2}>
        <Divider sx={{ width: "100%", marginBottom: 2 }} />
        <Typography variant="h6">
          {t(translationPath + "config_access")}
        </Typography>
      </Grid>

      <RolesEstablishments />

      <Grid item xs={12}>
        <AutoCompleteMulti
          params={{}}
          size="small"
          label={t(translationPath + "roles_profile") || "Roles"}
          name={"profiles"}
          request={profilesService.list}
        />
      </Grid>

      {showPrivileges && <RolesPrivileges />}
    </Grid>
  );
};

export default RolesBasicData;
